import { getSettingValueWithoutAssignment } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";
import { ITimestampRange } from "@faire/web-api--source/indigofair/data/ITimestampRange";
import { ITimestamp } from "@faire/web-api--source/indigofair/rfc3339/ITimestamp";
import { SPECIAL_HOLIDAY_NET90_TIMERANGE } from "@faire/web-api--source/indigofair/settings/SPECIAL_HOLIDAY_NET90_TIMERANGE";
import { SPECIAL_HOLIDAY_NET90_TIMEZONE } from "@faire/web-api--source/indigofair/settings/SPECIAL_HOLIDAY_NET90_TIMEZONE";
import isWithinInterval from "date-fns/isWithinInterval";
export var getSettingSpecialHolidayNet90TimeRange = function() {
    return getSettingValueWithoutAssignment(SPECIAL_HOLIDAY_NET90_TIMERANGE, ITimestampRange.build({
        start_at: ITimestamp.build({
            seconds: 0,
            nanos: 0
        }),
        end_at: ITimestamp.build({
            seconds: 0,
            nanos: 0
        })
    }));
};
export var getSettingSpecialHolidayNet90Timezone = function() {
    return getSettingValueWithoutAssignment(SPECIAL_HOLIDAY_NET90_TIMEZONE, "");
};
export var specialHolidayNet90Active = function() {
    var _getSettingSpecialHolidayNet90TimeRange = getSettingSpecialHolidayNet90TimeRange(), start_at = _getSettingSpecialHolidayNet90TimeRange.start_at, end_at = _getSettingSpecialHolidayNet90TimeRange.end_at;
    var _start_at_seconds, _end_at_seconds;
    return isWithinInterval(Date.now(), {
        start: ((_start_at_seconds = start_at === null || start_at === void 0 ? void 0 : start_at.seconds) !== null && _start_at_seconds !== void 0 ? _start_at_seconds : 0) * 1000,
        end: ((_end_at_seconds = end_at === null || end_at === void 0 ? void 0 : end_at.seconds) !== null && _end_at_seconds !== void 0 ? _end_at_seconds : 0) * 1000
    });
};
